export enum RssScrollDirection {
  RightToLeft,
  LeftToRight
}
